import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogoutService } from 'projects/common/src/app/services/logout.service';
import { LanguageService } from 'projects/common/src/app/services/parameters/language/language.service';
import { AuthenticationService } from 'src/app/services/authentication';
import { IModalLogout } from '../../interfaces/logout';

@Component({
  selector: 'app-modal-logout',
  templateUrl: './modal-logout.component.html',
  styleUrls: ['./modal-logout.component.scss'],
})
export class ModalLogoutComponent {
  public option: IModalLogout;
  public errorMsg: string;
  constructor(
    public activeModal: NgbActiveModal,
    private logoutService: LogoutService,
    private authenticationService: AuthenticationService,
    private languageService: LanguageService,
  ) {}

  public logout(): void {
    this.logoutService.logoutSession().subscribe({
      next: () => {
        this.authenticationService.cleanSession();
        this.activeModal.close();
      },
      error: () => {
        this.errorMsg = this.languageService.message('server_error');
      },
    });
  }
}
